import React from 'react';
import Framework from "@beardeddevops/react.framework";
import {Objects} from "components";
import {Button} from "reactstrap";
import Lockable from "components/Lockable";
import UniversalModalOverride from "components/UniversalModalOverride";

class One_Pages extends Lockable {

	constructor(props) {
		super(props);
		this.state.editing = false;
	}

	handleEditToggle = () => {
		this.setState({editing: !this.state.editing});
	}

	handleLockDevice = () => {
		this.handleSetPin(1);
	}

	handleToggleSendToKioskModal = () => {
		this.setState({sendToKioskModalOpen: !this.state.sendToKioskModalOpen});

	}

	handleSendToKioskClick =  () => {
		/*this.setState({id: state.id, binary_id: state.binary_id});*/
		this.handleToggleSendToKioskModal();
	}

	handleAfterKiosk = () => {
		this.setState({id: null, binary_id: null, object: null});
		// this.props.reloadPage();
		this.props.history.push('/dispositions/pendings');
	}

	render() {
		let {editing} = this.state;

		let breadcrumbs = [
			{
				name: 'Dashboard',
				url: this.props.kioskMode ? '/dispositions/one_page' : '/',
				icon: 'dashboard',
			},
			{
				name: 'Dispositions',
				url: this.props.kioskMode ? '/dispositions/one_page' : '/dispositions',
				icon: 'upload',
			},
			{
				name: 'One Page 4473',
				url: '/dispositions/one_page',
				icon: 'file-pdf-o',
			},
		];

		return (
			<div className="container-fluid">

				<Framework.Components.PageBar breadcrumbs={breadcrumbs} history={this.props.history}>
					{!this.props.kioskMode && Object.keys(this.props.match.params).length > 0 &&
						<Button onClick={this.handleEditToggle} size="sm" color="default">
							<i className="fa fa-pencil"/>&nbsp;&nbsp;{editing ? 'Cancel Edit' : 'Edit'}
						</Button>
					}
					{!this.props.kioskMode && Object.keys(this.props.match.params).length > 0 &&
						<Button onClick={this.handleLockDevice} size="sm" color="secondary">
							<i className="fa fa-lock"/>&nbsp;&nbsp;Lock Device
						</Button>
					}
					{!this.props.kioskMode && Object.keys(this.props.match.params).length > 0 &&
						<Button onClick={this.handleSendToKioskClick} size="sm" color="warning">
							<i className="fa fa-arrow-left"/>&nbsp;&nbsp;Send To Kiosk
						</Button>
					}
				</Framework.Components.PageBar>

				<Objects.OnePage
					id={this.props.match.params.id}
					customer={this.props.match.params.customer}
					history={this.props.history}
					locations={this.props.locations}
					states={this.props.states}
					kiosks={this.props.kiosks}
					reloadShell={this.props.reloadShell}
					reloadPage={this.refreshPage}
					reloadSelf={this.state.refresh}
					editing={editing}
					kioskMode={this.props.kioskMode}
					baseUrl="/dispositions/one_page"
				/>

				<UniversalModalOverride
					locations={this.props.locations}
					kiosks={this.props.kiosks}
					states={this.props.states}
					history={this.props.history}
					id={this.props.match.params.id}
					name={"Send to Kiosk"}
					object={Objects.SendToKiosk}
					/*objectProps={{
						object: this.state.object
					}}*/
					showModal={this.state.sendToKioskModalOpen}
					handleToggle={this.handleToggleSendToKioskModal}
					afterSave={this.handleAfterKiosk}
					hideGoTo={true}
				/>

			</div>
		);
	}
}

export default Framework.Components.withRootState(One_Pages);
